"use strict";
/*
 * PHPConfig - Loads Uniter's PHP configuration
 * Copyright (c) Dan Phillimore (asmblah)
 * https://github.com/uniter/phpconfig/
 *
 * Released under the MIT license
 * https://github.com/uniter/phpconfig/raw/master/MIT-LICENSE.txt
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConfigLoader = exports.configImporter = void 0;
var Config_1 = require("./Config");
var ConfigExporter_1 = require("./ConfigExporter");
var ConfigImporter_1 = require("./ConfigImporter");
var ConfigLoader_1 = require("./ConfigLoader");
var ConfigSet_1 = require("./ConfigSet");
var Loader_1 = require("./Loader");
var Requirer_1 = require("./Requirer");
var SerialisationChecker_1 = require("./SerialisationChecker");
var UNIFIED_CONFIG_FILE_NAME = 'uniter.config.js';
var requirer = new Requirer_1.default(require);
var createConfigLoader = function (existsSync) {
    return new ConfigLoader_1.default(requirer, new Loader_1.default(existsSync, requirer, UNIFIED_CONFIG_FILE_NAME), new ConfigExporter_1.default(new SerialisationChecker_1.default()), Config_1.default, ConfigSet_1.default);
};
exports.createConfigLoader = createConfigLoader;
var configImporter = new ConfigImporter_1.default(ConfigSet_1.default);
exports.configImporter = configImporter;
//# sourceMappingURL=index.js.map